import { MissingStateActions, SET_FAULTY_SECTIONS, SET_UNFINISHED_MODULE } from './types';
import { PopOverSceneItemData } from 'sofa-reborn-react';

export function setFaultySections(
	unfinishedSections: PopOverSceneItemData[],
	missingCoverSections: PopOverSceneItemData[],
	standaloneSofabed: PopOverSceneItemData[]
): MissingStateActions {
	return {
		type: SET_FAULTY_SECTIONS,
		unfinishedSections,
		missingCoverSections,
		standaloneSofabed,
	};
}

export function setUnfinishedModule(
	unfinishedModule: PopOverSceneItemData | null
): MissingStateActions {
	return {
		type: SET_UNFINISHED_MODULE,
		value: unfinishedModule,
	};
}
